import InicioInscricao from '../../views/Inscricao/Inicio';
import FormInscricao from '../../views/Inscricao/Form';
import DadosFatura from '../../views/Fatura/DadosFatura';
import ReciboCandidato from '../../views/Recibo/Candidato';
import FormLocalProvaEscolha from '../../views/LocalProva/FormEscolha';
import FormLocalProvaConfirmacao from '../../views/LocalProva/FormConfirmacao';
import FormEscolaAtuacao from '../../views/Escola/Form';
import { __ADMINISTRADOR, __CENTRAL, __CANDIDATO } from '../../security/RoleConfiguration';

export const path = '/admin/inscricao';

export const listRoutes = [
    {
        path: `${path}/:id/comprovante`,
        component: ReciboCandidato,
        roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO ],
    },
    {
        path: `${path}/:id/pagamento/fatura`,
        component: DadosFatura,
        roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO ],
    },
    {
        path: `${path}/:id/editar`,
        component: FormInscricao,
        roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO ],
    },
    {
        path: `${path}/:id/local-prova`,
        component: FormLocalProvaEscolha,
        roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO ],
    },
    {
        path: `${path}/:id/local-prova/confirmar`,
        component: FormLocalProvaConfirmacao,
        roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO ],
    },
    {
        path: `${path}/:id/escola-atuacao`,
        component: FormEscolaAtuacao,
        roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO ],
    },
];

export const listRoutesPublic = [
    {
        path: `/inscricao`,
        component: InicioInscricao,
        roles: [],
    },
    {
        path: `/inscricao/:id`,
        component: FormInscricao,
        roles: [],
    },
];

export default listRoutes;